import { useState } from "react";

import styled from "styled-components/macro";

import { useBoards } from "Boards/BoardContext";
import Filters from "Boards/Filters";
import { BOARD_TYPES } from "Boards/const";
import MoreOptionsSignupBoardButton from "Signups/SignupView/SignupSheet/Screens/RespondentsData/MoreOptionsSignupBoardButton";

import BoardTitle from "./BoardTitle";
import DeleteAndArchiveButton from "./DeleteAndArchiveButton";
import DuplicateButton from "./DuplicateButton";
import ExportButton from "./ExportButton";
import useBoardLocation from "./hooks/useBoardLocation";

export default function ControlRow() {
  const [
    { boardID, boardTitle, groupURL, isShared, boardType, savedBoardFilter },
  ] = useBoards();
  const [isFiltering, setIsFiltering] = useState(false);
  const { isReportBoard } = useBoardLocation();

  if (boardType === BOARD_TYPES.SIGNUP) {
    // Signup boards show a more options button, but do not need to show the title or board control buttons
    return (
      <MoreOptionsWrapper>
        <MoreOptionsSignupBoardButton />
      </MoreOptionsWrapper>
    );
  }

  return (
    <Wrapper $isReportsBoard={isReportBoard}>
      <BoardTitle data-cy="sheetTitle" />
      <BoardControlButtons
        $isReportsBoard={isReportBoard}
        $isFiltering={isFiltering}
      >
        <FiltersWrapper>
          <Filters setIsFiltering={setIsFiltering} />
        </FiltersWrapper>
        <IconBtnsWrapper>
          <ExportButton
            boardID={boardID}
            groupURL={groupURL}
            savedFilterRequestID={savedBoardFilter?.savedFilterRequestID}
          />
          <DuplicateButton boardID={boardID} boardTitle={boardTitle} />
          <DeleteAndArchiveButton />
        </IconBtnsWrapper>
      </BoardControlButtons>
    </Wrapper>
  );
}

const smallScreen = "840px";
const mobileScreen = "464px";

const Wrapper = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: ${(p) => (p.$isReportsBoard ? "128px" : "0")};

  @media screen and (max-width: ${smallScreen}) {
    display: ${(p) => (p.$isReportsBoard ? "grid" : "flex")};
    gap: 8px;
  }

  @media screen and (max-width: ${mobileScreen}) {
    padding-top: ${(p) => (p.$isReportsBoard ? "54px" : "0")};
    margin-left: 0;
  }
`;

const BoardControlButtons = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (max-width: ${smallScreen}) {
    margin-left: ${(p) =>
      p.$isFiltering ? 0 : p.$isReportsBoard ? "-5px" : "-4px"};
  }
`;

const IconBtnsWrapper = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: ${mobileScreen}) {
    margin-left: 12px;
  }
`;

const MoreOptionsWrapper = styled.div`
  position: absolute;
  top: 1px;
  z-index: 1000;
`;

const FiltersWrapper = styled.div`
  height: 32px;
  font-size: 14px;
  color: #15436a;
  margin-right: 8px;

  .filtering {
    color: white;
  }
`;
